import React, { useState, useEffect, useRef } from "react";
import { FaTimes } from "react-icons/fa";
import StripePayment from "../Stripe/StripePayment";
import { useTranslation } from "react-i18next"; // Add this import

const PurchaseCoin = () => {
  const { t } = useTranslation();
  const [coinInput, setCoinInput] = useState("");
  const [promotionCode, setPromotionCode] = useState("");
  const [promotionPercentage, setPromotionPercentage] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [isPromoInputVisible, setIsPromoInputVisible] = useState(false);
  const [notification, setNotification] = useState("");
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isTransactionSuccessful, setTransactionSuccessful] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showGemBonusModal, setShowGemBonusModal] = useState(false);

  // select a purchase button (sets the input and marks the button)
  const handleSelect = (option) => {
    if (selectedOption === option.usd) {
      // Deselect if already selected
      setSelectedOption(null);
      setCoinInput("");
      setTotalCost(0);
    } else {
      setCoinInput(option.usd.toString());
      setSelectedOption(option.usd);
      setTotalCost(option.usd);
    }
  };
  useEffect(() => {
    setCoinInput("");
    setPromotionCode("");
    setPromotionPercentage(0);
    setTotalCost(0);
  }, []);

  // const handleCoinInputChange = (e) => {
  //   let value = e.target.value;
    
  //   // Remove the dollar sign if present
  //   value = value.replace(/\$/g, '');
    
  //   // Remove leading zeros
  //   value = value.replace(/^0+/, '');
    
  //   const amount = parseInt(value, 10) || 0;
  //   setCoinInput(value);
  //   setTotalCost(amount);
  // };
  const handleCoinInputChange = (e) => {
    let value = e.target.value.replace(/\$/g, '');
    value = value.replace(/[^0-9.]/g, '');

    // Prevent multiple decimals
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }

    // Remove leading zeros unless before decimal
    if (value && value[0] === '0' && value[1] !== '.') {
      value = value.replace(/^0+/, '');
    }

    setCoinInput(value);

    // Parse as float for cents support
    const amount = parseFloat(value) || 0;
    setTotalCost(amount);

    // Highlight matching option if input matches
    const matchedOption = purchaseOptions.find(opt => Number(opt.usd) === amount);
    setSelectedOption(matchedOption ? matchedOption.usd : null);
  };

  const handleCoinInputBlur = () => {
    if (coinInput) {
      const num = parseFloat(coinInput);
      if (!isNaN(num)) {
        setCoinInput(num.toFixed(2));
      }
    }
  };

  const userID = localStorage.getItem("userID");

  const fetchData = async () => {
    try {
      // Make the GET request
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/booking/getTotal?ID=${userID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Check if the response is OK
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      // Parse the JSON response
      const data = await response.json();
      localStorage.setItem("coins", data[0].COINS);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    window.location.reload();
  };

  const handleApplyPromotionCode = () => {
    let discount = 0;
    switch (promotionCode.toLowerCase()) {
      case "promo20":
        discount = 20;
        break;
      case "promo30":
        discount = 30;
        break;
      case "promo50":
        discount = 50;
        break;
      default:
        setNotification(t('purchaseCoin.invalidPromotionCode'));
        setIsNotificationOpen(true);
        return;
    }
    setPromotionPercentage(discount);
    setNotification(t('purchaseCoin.promotionCodeApplied', { discount }));
    setIsNotificationOpen(true);
    setIsPromoInputVisible(false);
  };

  const handlePurchase = async () => {
    const finalCost = totalCost * (1 - promotionPercentage / 100);

    const today = new Date().toISOString().split("T")[0];
    const userID = localStorage.getItem("userID");

    // Determine gems to send: use selected button's gems if matched, else use custom input
    let gemsToSend = 0;
    const selectedOption = purchaseOptions.find(opt => opt.usd.toString() === coinInput);
    if (selectedOption) {
      gemsToSend = Math.round(selectedOption.gems * (1 - promotionPercentage / 100));
    } else {
      gemsToSend = Math.round((totalCost * (1 - promotionPercentage / 100)) * 10);
    }

    const purchasePost = {
      prefix: "PCN",
      items: [
        {
          CustomerId: userID,
          pid: 0,
          Quantity: gemsToSend,
          Amount: finalCost,
          //Gems: gemsToSend, // <-- Add gems to payload
        },
      ],
    };

    try {
      const response = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/member/PostPurchaseCoin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(purchasePost),
        }
      );

      const data = await response.json();

      if (data) {
        console.log(`Purchase successful`);
        console.log(data);
        fetchData();
      } else {
        console.log("Did not work");
      }
    } catch (error) {
      console.log(`Error: ${error.message}`);
    }

    // Retrieve the current coin balance from localStorage
    const currentCoins = parseInt(localStorage.getItem("coins")) || 0;

    // Update local coins with gemsToSend
    const updatedCoins = currentCoins + gemsToSend;

    localStorage.setItem("coins", updatedCoins);

    setTransactionSuccessful(true);
  };

  const handleTogglePromoInput = () => {
    setIsPromoInputVisible(!isPromoInputVisible);
  };

  const closeNotification = () => {
    setIsNotificationOpen(false);
  };

  const closeTransactionModal = () => {
    setTransactionSuccessful(false);
  };

  //Stripe
  const [modalOpen, setModalOpen] = useState(false);
  const [guardianModal, setGuardianModal] = useState(false);
  const userAgeRef = useRef(undefined);

  const fetchUserAge = async () => {
    // test
    // return 15; // TEMP: force under-18 to test guardian modal — remove before commit
    if (userAgeRef.current !== undefined) return userAgeRef.current;
    try {
      const res = await fetch("https://xianhefairy.com/LotusFairy_API/api/User/GetProfile", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          UserName: localStorage.getItem("username") || "",
          ID: parseInt(userID || "0", 10),
          LangId: parseInt(localStorage.getItem("languageId") || "2224", 10) || 2224,
          UserToken: "",
          Token: { AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp" },
        }),
      });
      if (!res.ok) { userAgeRef.current = null; return null; }
      const data = await res.json();
      const age = data?.Profiles?.[0]?.Age ?? null;
      userAgeRef.current = age;
      return age;
    } catch {
      userAgeRef.current = null;
      return null;
    }
  };

  const openModal = async () => {
    const age = await fetchUserAge();
    if (age !== null && age < 18) {
      setGuardianModal(true);
    } else {
      setModalOpen(true);
    }
  };

  // Determine a selected plan — for now we map coin purchases to a default plan id
  // Assumption: the app doesn't use different named plans here; use a simple fallback
  const selectedPlan = coinInput && Number(coinInput) > 0 ? "coins" : "coins";

  // Wrapper for payment success to reuse existing purchase logic
  const handlePaymentSuccess = async () => {
    // Call the existing purchase handler
    await handlePurchase();
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    // Close modal if the user clicks outside
    const handleOutsideClick = (e) => {
      const modal = document.getElementById("stripeModal"); // Target the modal element
      if (modal && !modal.contains(e.target)) {
        setModalOpen(false); // Close modal if clicked outside
      }
    };

    if (modalOpen) {
      document.addEventListener("mousedown", handleOutsideClick); // Add event listener
    }

    // Cleanup the event listener when modal is closed
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [modalOpen]); // Only run when modalOpen changes

  // const purchaseOptions = [
  //   { usd: 0.99, gems: 10, label: "0.99 USD - 10 Gems" },
  //   { usd: 4.99, gems: 50, label: "4.99 USD - 50 Gems" },
  //   { usd: 9.99, gems: 110, label: "9.99 USD - 110 Gems" },
  //   { usd: 19.99, gems: 220, label: "19.99 USD - 220 Gems" },
  //   { usd: 49.99, gems: 560, label: "49.99 USD - 560 Gems" },
  //   { usd: 99.99, gems: 1120, label: "99.99 USD - 1120 Gems" },
  //   { usd: 199.99, gems: 2300, label: "199.99 USD - 2300 Gems" },
  //   { usd: 499.99, gems: 5750, label: "499.99 USD - 5750 Gems" },
  // ];

  const [purchaseOptions, setPurchaseOptions] = useState([]);

  useEffect(() => {
    const fetchGemOptions = async () => {
      try {
        const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Product/GetGemOptions?CustId=${userID}`);
        const data = await response.json();
        // Map API data to your button format
        const options = data.map(opt => ({
          usd: Number(opt.Amount),
          gems: Number(opt.Gem),
          label: `US$ ${opt.Amount} - ${opt.Gem} Gems`,
          uid: opt.Uid,
        }));
        setPurchaseOptions(options);
      } catch (error) {
        console.error("Failed to fetch gem options:", error);
      }
    };
    fetchGemOptions();
  }, []);

  // Media queries for breakpoints
  // Injected via a <style> tag for global effect
  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `
      /* Desktop: center the row */
      @media (min-width: 1376px) {
        .purchase-options-row {
          justify-content: center !important;
          max-width: 80vw;
          width: 100%;
          overflow-x: unset !important;
        }
        .gem-input {
          width: 20vw !important;
        }
        .dollar-sign-input {
          left: 16% !important;
          color: black !important;
        }
      }
      /* Tablet and below: scrollable and left-aligned */
      @media (max-width: 1375px) {
        .purchase-options-row {
          justify-content: flex-start !important;
          max-width: 100vw;
          width: 100vw;
          overflow-x: auto !important;
          margin-left: 0 !important;
          margin-right: 0 !important;
          box-sizing: border-box;
          scroll-padding-left: 16px;
        }
        .purchase-option-btn {
          min-width: 200px;
          width: 70vw;
          height: 60px;
          font-size: 1rem;
        }
        .gem-input {
          width: 30vw !important;
        }
        .dollar-sign-input {
          left: 8% !important;
          color: black !important;
        }
      }
      @media (max-width: 1024px) {
        .dollar-sign-input {
          left: 14% !important;
          color: black !important;
        }
      }
      @media (max-width: 768px) {
        .gem-input {
          width: 50vw !important;
        }
        .dollar-sign-input {
          left: 10% !important;
          color: black !important;
        }
      }
      @media (min-width: 769px) and (max-width: 1024px) {
        .purchase-options-row {
          grid-template-columns: repeat(3, minmax(160px, 1fr)) !important;
          grid-auto-rows: min-content !important;
          columnGap: "8px", // small horizontal gap
          rowGap: "10px",
          justifyContent: "center",
          alignItems: "center",
          margin: "0 auto 16px",
          width: "100%",
          maxWidth: "1100px", // prevent overly wide distribution
          boxSizing: "border-box",
          paddingBottom: "8px",
        }
        .page-container {
          padding: 20px 0 !important;
          // min-height: 100vh !important;
        }
        .page-content {
          padding: 20px 0 !important;
          // min-height: auto !important;
        }
      }

      @media (max-width: 768px) {
        .purchase-options-row {
          grid-template-columns: repeat(3, minmax(160px, 1fr)) !important;
          grid-auto-rows: min-content !important;
          columnGap: "8px", // small horizontal gap
          rowGap: "10px",
          justifyContent: "center",
          alignItems: "center",
          margin: "0 auto 16px",
          width: "100%",
          maxWidth: "1100px", // prevent overly wide distribution
          boxSizing: "border-box",
          paddingBottom: "8px",
        }
      }
      @media (max-width: 480px) {
        .purchase-options-row {
          grid-template-columns: repeat(2, minmax(160px, 1fr)) !important;
          grid-auto-rows: min-content !important;
          columnGap: "8px", // small horizontal gap
          rowGap: "10px",
          justifyContent: "center",
          alignItems: "center",
          margin: "0 auto 16px",
          width: "100%",
          maxWidth: "1100px", // prevent overly wide distribution
          boxSizing: "border-box",
          paddingBottom: "8px",
        }
        .purchase-option-btn {
          background-color: transparent !important;
          color: #DFBD69 !important;
          border: 1px solid #DFBD69 !important;
          font-weight: normal !important;
          transition: background 0.2s, color 0.2s, border 0.2s;
          height: 48px !important;         /* Lower button height */
          font-size: 15px !important;      /* Lower button text size */
          display: flex !important;
          text-align: center !important;
          align-items: center !important; /* Move text lower inside button */
          padding-bottom: 6px !important;   /* Add space below text */
          width: 20vw !important;          /* Make buttons wider */
        }
      }
      /* Unselected styles for purchase option buttons */
      .purchase-option-btn {
        background-color: transparent !important;
        color: #DFBD69 !important;
        border: 1px solid #DFBD69 !important;
        font-weight: normal !important;
        transition: background 0.2s, color 0.2s, border 0.2s;
      }
      /* Hover styles for purchase option buttons */
      .purchase-option-btn:hover {
        background-color: #dfbd69 !important;
        color: black !important;
        border: 2px solid #b8860b !important;
        font-weight: bold !important;
        transition: background 0.2s, color 0.2s, border 0.2s;
      }
      /* Selected styles for purchase option buttons */
      .purchase-option-btn.selected {
        background-color: #dfbd69 !important;
        color: black !important;
        border: 2px solid #dfbd69 !important;
        font-weight: bold !important;
        scale: 1.05;
      }
    `;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);
  
  const columns = 4; // number of buttons per row

  return (
    <div className="page-container" style={pageContainerStyle}>
      <div className="page-content" style={pageContentStyle}>
        <h2 style={{ color: "#DFBD69" }}>{t('purchaseCoin.title')}</h2>

        <div style={inputContainerStyle}>
          <div style={{ marginBottom: "10px", color: "#DFBD69", fontSize: "16px" }}>
            {t('purchaseCoin.selectOption')}
          </div>
          <div
            className="purchase-options-row"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gridTemplateRows: "repeat(2, auto)",
              gap: "12px",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 auto 16px",
              width: "100%",
              maxWidth: "900px",
              boxSizing: "border-box",
              paddingBottom: "8px",
            }}
          >
            {purchaseOptions.map((option, idx) => (
              <button
                key={option.usd}
                onClick={() => handleSelect(option)}
                className={`purchase-option-btn ${selectedOption === option.usd ? "selected" : ""}`}
                style={{
                  ...responsiveButtonStyle,
                  marginLeft: "0px",
                  zIndex: 1,
                }}
              >
                {t('purchaseCoin.optionLabel', { amount: option.usd, gems: option.gems })}
              </button>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: "20px", textAlign: "center" }}>
          <div style={{ color: "#DFBD69", fontSize: "20px", marginBottom: "14px" }}>
            {t('purchaseCoin.ambassadorBonusInfo')}
          </div>
          <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
            <button
              onClick={() => setShowGemBonusModal(true)}
              style={{
                background: "transparent",
                color: "#DFBD69",
                border: "1px solid #DFBD69",
                borderRadius: "6px",
                padding: "8px 18px",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: "15px",
              }}
            >
              {t('purchaseCoin.compareGemBonuses')}
            </button>
            <a
              href="/affiliatepartner"
              style={{
                background: "#DFBD69",
                color: "#151517",
                border: "1px solid #DFBD69",
                borderRadius: "6px",
                padding: "8px 18px",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: "15px",
                textDecoration: "none",
                display: "inline-block",
              }}
            >
              {t('purchaseCoin.signUpAsAmbassador')}
            </a>
          </div>
        </div>

       <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          marginBottom: "10px",
          textAlign: "center",
        }}
        >
        <input
          type="text"
          value={coinInput ? `US$${coinInput}` : ''}
          onChange={handleCoinInputChange}
          onBlur={handleCoinInputBlur}
          placeholder={t('purchaseCoin.enterAmountPlaceholder')}
          style={{
            ...inputStyle,
            width: "400px",
            maxWidth: "90vw",
            paddingLeft: "10px",
            boxSizing: "border-box",
            textAlign: "left",
            backgroundColor: "#222",
            color: "#DFBD69",
            opacity: 0.7,
            cursor: "not-allowed",
          }}
          className="gem-input"
          disabled
        />
        </div>

        <div style={{ color: "#DFBD69", marginBottom: "10px", fontSize: "16px" }}>
          {t('purchaseCoin.conversionRate')}
        </div>
        <button style={confirmButtonStyle} onClick={openModal}>
          {t('purchaseCoin.confirm')}
        </button>

        {/* Move promotion code section BELOW Confirm button */}
        <div style={{ marginTop: "20px" }}>
          {!isPromoInputVisible && !promotionPercentage && (
            <button style={applyButtonStyle} onClick={handleTogglePromoInput}>
              {t('purchaseCoin.enterPromotionCode')}
            </button>
          )}

          {isPromoInputVisible && (
            <div style={inputContainerStyle}>
              <input
                type="text"
                value={promotionCode}
                onChange={(e) => setPromotionCode(e.target.value)}
                placeholder={t('purchaseCoin.promotionCodePlaceholder')}
                style={inputStyle}
              />
              <button style={applyButtonStyle} onClick={handleApplyPromotionCode}>
                {t('purchaseCoin.applyPromotionCode')}
              </button>
            </div>
          )}
        </div>

        <div style={totalStyle}>
          {t('purchaseCoin.totalGems')}:{" "}
          {coinInput && purchaseOptions.some(opt => opt.usd.toString() === coinInput)
            ? (
                purchaseOptions.find(opt => opt.usd.toString() === coinInput).gems *
                (1 - promotionPercentage / 100)
              ).toFixed(2)
            : ((totalCost * (1 - promotionPercentage / 100)) * 10).toFixed(2)
          }
        </div>
      </div>

      {/* Notification Modal */}
      {isNotificationOpen && (
        <div style={notificationOverlayStyle} onClick={closeNotification}>
          <div style={notificationModalStyle}>
            <p>{notification}</p>
          </div>
        </div>
      )}

      {/* Stripe Payment Modal */}
      <div>
        {modalOpen && (
          (() => {
            const stripeAmount = Number((totalCost * (1 - promotionPercentage / 100)).toFixed(2));
            const stripeGems =
              coinInput && purchaseOptions.some(opt => opt.usd.toString() === coinInput)
                ? Math.round(purchaseOptions.find(opt => opt.usd.toString() === coinInput).gems * (1 - promotionPercentage / 100))
                : Math.round((totalCost * (1 - promotionPercentage / 100)) * 10);

            console.log("Sending to Stripe:", {
              id: selectedPlan,
              amount: stripeAmount,
              gems: stripeGems,
              currency: "usd",
              isOpen: modalOpen,
            });

            return (
              <div style={styles.modalOverlay} onClick={closeModal}>
                <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                  <StripePayment
                    id={selectedPlan}
                    amount={stripeAmount}
                    gems={stripeGems}
                    currency="usd"
                    isOpen={modalOpen}
                    onClose={closeModal}
                    onPaymentSuccess={handlePaymentSuccess}
                  />
                </div>
              </div>
            );
          })()
        )}
      </div>

      {/* Guardian Confirmation Modal */}
      {guardianModal && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10002 }}
          onClick={() => setGuardianModal(false)}>
          <div style={{ backgroundColor: "#1a1a1a", borderRadius: 12, padding: "28px 24px", width: "min(460px, 92vw)", textAlign: "center", boxShadow: "0 8px 32px rgba(0,0,0,0.45)", border: "1px solid rgba(223,189,105,0.25)" }}
            onClick={(e) => e.stopPropagation()}>
            <h3 style={{ color: "#DFBD69", margin: "0 0 16px", fontSize: "1.2rem" }}>{t("cart.guardianConfirmationRequired")}</h3>
            <p style={{ color: "#fff2d2", marginBottom: 28, lineHeight: 1.6 }}>{t("cart.guardianMessage")}</p>
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <button style={{ background: "#DFBD69", color: "#151517", border: "none", borderRadius: 8, padding: "10px 22px", fontWeight: 700, cursor: "pointer", fontSize: "0.95rem" }}
                onClick={() => { setGuardianModal(false); setModalOpen(true); }}>
                {t("cart.yesProceed")}
              </button>
              <button style={{ background: "transparent", color: "#DFBD69", border: "1px solid rgba(223,189,105,0.4)", borderRadius: 8, padding: "10px 22px", cursor: "pointer", fontSize: "0.95rem" }}
                onClick={() => setGuardianModal(false)}>
                {t("cart.noCancel")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Gem Bonus Comparison Modal */}
      {showGemBonusModal && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10002 }}
          onClick={() => setShowGemBonusModal(false)}>
          <div style={{ backgroundColor: "#1a1a1a", borderRadius: 12, padding: "28px 24px", width: "min(640px, 94vw)", boxShadow: "0 8px 32px rgba(0,0,0,0.45)", border: "1px solid rgba(223,189,105,0.25)", position: "relative" }}
            onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setShowGemBonusModal(false)}
              style={{ position: "absolute", top: 16, right: 16, background: "transparent", border: "none", color: "#DFBD69", cursor: "pointer", fontSize: "1.1rem" }}
            >
              <FaTimes />
            </button>
            <h3 style={{ color: "#DFBD69", margin: "0 0 20px", fontSize: "1.2rem", textAlign: "center" }}>
              {t('purchaseCoin.gemBonusTable.title')}
            </h3>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "560px" }}>
                <thead>
                  <tr style={{ backgroundColor: "#c9c9c9" }}>
                    {[
                      t('purchaseCoin.gemBonusTable.priceUsd'),
                      t('purchaseCoin.gemBonusTable.explorer'),
                      t('purchaseCoin.gemBonusTable.ambassador'),
                      t('purchaseCoin.gemBonusTable.plusAmount'),
                      t('purchaseCoin.gemBonusTable.plusPercent'),
                    ].map((heading, idx) => (
                      <th key={idx} style={{ padding: "10px 12px", color: "#151517", fontWeight: 700, fontSize: "0.9rem", textAlign: "center", border: "1px solid #444" }}>
                        {heading}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {gemBonusTableRows.map((row, idx) => (
                    <tr key={idx}>
                      <td style={{ padding: "8px 12px", color: "#DFBD69", textAlign: "center", border: "1px solid #444" }}>{row.price}</td>
                      <td style={{ padding: "8px 12px", color: "#fff2d2", textAlign: "center", border: "1px solid #444" }}>{row.explorer}</td>
                      <td style={{ padding: "8px 12px", color: "#fff2d2", textAlign: "center", border: "1px solid #444" }}>{row.ambassador}</td>
                      <td style={{ padding: "8px 12px", color: "#fff2d2", textAlign: "center", border: "1px solid #444" }}>{row.plusAmount}</td>
                      <td style={{ padding: "8px 12px", color: "#fff2d2", textAlign: "center", border: "1px solid #444" }}>{row.plusPercent}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const gemBonusTableRows = [
  { price: "$0.99", explorer: "10 Gem", ambassador: "10 Gem", plusAmount: "--", plusPercent: "0%" },
  { price: "$4.99", explorer: "50 Gem", ambassador: "52 Gem", plusAmount: "+2", plusPercent: "+4%" },
  { price: "$9.99", explorer: "100 Gem", ambassador: "105 Gem", plusAmount: "+5", plusPercent: "+5%" },
  { price: "$49.99", explorer: "500 Gem", ambassador: "530 Gem", plusAmount: "+30", plusPercent: "+6%" },
  { price: "$99.99", explorer: "1,000 Gem", ambassador: "1,070 Gem", plusAmount: "+70", plusPercent: "+7%" },
  { price: "$199.99", explorer: "2,000 Gem", ambassador: "2,150 Gem", plusAmount: "+150", plusPercent: "+7.5%" },
  { price: "$499.99", explorer: "5,000 Gem", ambassador: "5,400 Gem", plusAmount: "+400", plusPercent: "+8%" },
  { price: "$999.00", explorer: "10,000 Gem", ambassador: "10,850 Gem", plusAmount: "+850", plusPercent: "+8.5%" },
  { price: "$4,999.00", explorer: "50,000 Gem", ambassador: "54,500 Gem", plusAmount: "+4,500", plusPercent: "+9%" },
  { price: "$9,999.00", explorer: "100,000 Gem", ambassador: "110,000 Gem", plusAmount: "+10,000", plusPercent: "+10%" },
];

// Page styles
const pageContainerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start", // Changed from "center"
  minHeight: "100vh", // Changed from height: "80vh"
  backgroundColor: "black",
  padding: "20px 0", // Add vertical padding
};

const modalStyles = {
  position: "fixed",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0",
  backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
  zIndex: "1000", // Ensures it appears on top of other content
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const modalContentStyle = {
  position: "relative", // Ensure positioning context for close button
  backgroundColor: "white",
  padding: "20px",
  paddingBottom: "40px", // Add extra padding at the bottom
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
};

const closeButtonStyle = {
  position: "absolute",
  top: "0px",
  right: "10px",
  bottom: "25px",
  background: "transparent",
  border: "none",
  fontSize: "24px",
  color: "#333",
  cursor: "pointer",
};

const pageContentStyle = {
  width: "100%",
  maxWidth: "100%",
  backgroundColor: "black",
  padding: "30px",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
  margin: "0 auto",
  minHeight: "auto",
  maxHeight: "80vh",         // <-- Add this line
  overflowY: "auto",         // <-- Add this line
};

const inputContainerStyle = {
  marginTop: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
};

const inputStyle = {
  padding: "10px",
  margin: "10px 0",
  width: "20%",
  borderRadius: "5px",
  border: "1px solid #ddd",
  fontSize: "16px",
};

const confirmButtonStyle = {
  backgroundColor: "#DFBD69",
  color: "black",
  border: "none",
  borderRadius: "5px",
  padding: "10px 20px",
  cursor: "pointer",
  fontSize: "16px",
  marginTop: "10px",
};

const applyButtonStyle = {
  backgroundColor: "#DFBD69",
  color: "black",
  border: "none",
  borderRadius: "5px",
  padding: "10px 20px",
  cursor: "pointer",
  fontSize: "16px",
  marginTop: "10px",
};

const totalStyle = {
  marginTop: "15px",
  fontWeight: "bold",
  fontSize: "18px",
  color: "#DFBD69",
};

const notificationOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1001,
};

const notificationModalStyle = {
  backgroundColor: "white",
  padding: "20px",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
};

// Responsive styles for purchase options row
const purchaseOptionsRowStyle = {
  display: "flex",
  flexDirection: "row",
  gap: "0px",            // remove default gap so overlap looks consistent
  justifyContent: "center",
  alignItems: "flex-start",
  flexWrap: "wrap",
  marginBottom: "16px",
  width: "100%",
  maxWidth: "1100px",
  boxSizing: "border-box",
  paddingBottom: "8px",
  margin: "0 auto 16px",
  overflowX: "visible",
};

const responsiveButtonStyle = {
  ...confirmButtonStyle,
  minWidth: "160px",     // allow buttons to shrink
  maxWidth: "220px",
  height: "60px",
  whiteSpace: "normal",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  fontSize: "18px",
  flex: "0 1 auto",
  marginBottom: "12px",
  position: "relative",  // required for zIndex to take effect per button
  transition: "transform 120ms ease",
};
// Styles used by the Stripe modal overlay/content
const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    maxWidth: "90%",
    width: "420px",
  },
};

export default PurchaseCoin;
